// extracted by mini-css-extract-plugin
export default {"loading":"Preloader_loading__yXeSH","dot":"Preloader_dot__Kue6G","spin":"Preloader_spin__hFayO","dot2":"Preloader_dot2__nqKcn","spin2":"Preloader_spin2__6wAoj"};